"use strict";

var _require = require('boolean'),
    parseBoolean = _require["boolean"];

function parseWaxSeals(params) {
  var quantity = 0;

  if (params.floral_invitations) {
    quantity = parseInt(params.floral_invitations, 10);
  }

  if (params.invitations) {
    quantity = parseInt(params.invitations, 10);
  }

  if (params.product_type === 'vellum reprint') {
    quantity = parseInt(params.REPRINT_invitations, 10);
  }

  if (params.product_type === 'covid invitations reprint') {
    quantity = parseInt(params.COVID_REPRINT_invitations, 10);
  }

  if (params.product_type === 'floral invitation reprint') {
    quantity = parseInt(params.REPRINT_floral_invitations, 10);
  }

  var wax_seal_style = 'None';

  if (params.product_type === 'floral invitations') {
    wax_seal_style = params['floral-waxseal-pers'];
  }

  if (params.product_type === 'wax seals') {
    wax_seal_style = "".concat(params.wax_seal_color, " ").concat(params.wax_seal_design);
  }

  if (params.product_type === 'vellum invitations') {
    wax_seal_style = params.wax_seal_invitations;
  }

  if (params.product_type === 'vellum reprint' && parseBoolean(params.REPRINT_wax_seals)) {
    wax_seal_style = 'Not specified';
  }

  if (params.product_type === 'covid invitations reprint' && parseBoolean(params.REPRINT_wax_seals)) {
    wax_seal_style = 'Not specified';
  }

  if (params.product_type === 'floral invitation reprint') {
    wax_seal_style = 'Not specified';
  }

  if (quantity && !wax_seal_style.match(/none/i)) {
    this.waxSeals.add({
      quantity: quantity,
      wax_seal_style: wax_seal_style
    });
  }
}

module.exports = parseWaxSeals;